import React from "react";
import MainVannerCSS from "./AboutUs_dev.module.css";

const imgToggleHandler1 = () => {
  var el = document.getElementById("img_src_001");
  el.src = 'img/en/main_12_4_1.png';
}
const imgToggleHandler2 = () => {
  var el = document.getElementById("img_src_001");
  el.src = 'img/en/main_12_5_1.png';
}
const imgToggleHandler3 = () => {
  var el = document.getElementById("img_src_001");
  el.src = 'img/en/main_12_6_1.png';
}

function MainVanner() {
  return (
    <div className={MainVannerCSS.baseStart}>    
      <img className={MainVannerCSS.back} src="img/en/main_11_1.png" alt="main" />     
      <img className={MainVannerCSS.back} src="img/en/main_12_top.png" alt="main" />       
      <img className={MainVannerCSS.back} src="img/en/main_12_4_1.png" id="img_src_001" alt="main"/>
      <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link1}>
          <img src="img/blank_300_150.png" alt="arrow" onClick={imgToggleHandler1} />
          </div>
        </div>   
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link2}>
          <img src="img/blank_300_150.png" alt="arrow" onClick={imgToggleHandler2} />
          </div>
        </div>   
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link3}>
          <img src="img/blank_300_150.png" alt="arrow" onClick={imgToggleHandler3} />
          </div>
        </div>      
      <img className={MainVannerCSS.back} src="img/en/main_13_1.png" alt="main" />
      <img className={MainVannerCSS.back} src="img/en/main_14_1.png" alt="main" />        
    </div>
  );
}
export default MainVanner;
